module.exports = __webpack_public_path__ + "static/media/tech_desk_rasppi.acc6810d.jpg";